import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface State {
  abbreviation: string;
  name: string;
}

interface StatesState {
  states: State[];
  error?: string;
}

const initialState: StatesState = {
  states: [],
  error: undefined,
};

const statesSlice = createSlice({
  name: "licensing/payment/states",
  initialState,
  reducers: {
    gotStates(state: StatesState, action: PayloadAction<State[]>) {
      state.states = action.payload;
      state.error = undefined;
    },
    errStates(state: StatesState, action: PayloadAction<string>) {
      state.error = action.payload;
    },
    resetStatesError(state: StatesState) {
      state.error = undefined;
    },
  },
});

export const { gotStates, errStates, resetStatesError } = statesSlice.actions;

export default statesSlice.reducer;
